export const QueryKeys = {
    GetAllOrdersBookings: 'get-all-orders-bookings',
}
